import { apiUrl } from "../../../Constant/apiConstant"
import { getRequest, postJsonRequest } from "../../../service/apiService"

export const getCandidates= async(tenant: string | undefined,payLoad:any)=>{
    try{
        const response= await postJsonRequest(apiUrl.JM_GET_CANDIDATES,payLoad,tenant,true)
        if(response.status === 200){
            return response.data
        }
    }catch(error){
        console.log(error)
    }
    return null
}

export const getCandidateNotes= async (tenant: string | undefined,mapId:number)=>{
    try{
        const response = await postJsonRequest(apiUrl.JM_GET_CANDIDATE_NOTES,{"MapID":mapId},tenant,true)

        if(response.status === 200){
            return response.data
        }
    }catch(error){
        console.log(error)
    }

    return []
}


export const addCandidateNote =async (tenant: string | undefined,payLoad: any)=>{
    try{
        const response= await postJsonRequest(apiUrl.JM_POST_ADD_CANDIDATE_NOTE,payLoad,tenant,true)
        if(response.status === 200 ){
            return response.data
        }
    }catch(error){
        console.log(error)
    }
    return null
}

export const deleteCandidate = async (tenant:string | undefined,payLoad:any)=>{
    try{
        const response =await postJsonRequest(apiUrl.JM_POST_DELETE_CANDIATE,payLoad,tenant,true)

        if(response.status === 200){
            return true
        }
    }catch(error){
        console.log(error)
    }
    return false
}

export const sendNotify = async (tenant:string | undefined,payLoad:any)=>{
    try{
        const response= await postJsonRequest(apiUrl.JM_POST_SEND_NOTIFY,payLoad,tenant,true)
        if(response.status === 200){
            const {Status,Message} = response.data

            return {Status,Message}
        }
    }catch(error){
        console.log(error)
    }
    return null

}

export const downloadResume = async (tenant: string | undefined, payLoad: any) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_POST_DOWNLOAD_RESUME, payLoad, tenant, true,'blob');
        if (response.status === 200) {
            return response
        }
    } catch (error) {
        console.log(error);
    }
    return null;
}


export const getCandidateStatusHistory = async (tenant: string | undefined, payLoad: any) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_GET_CANDIDATE_STATUS_HISTORY, payLoad, tenant, true);
        if (response.status === 200) {
            const {Status,Data}=response.data
            return Status ? Data : [];
        }
    } catch (error) {
        console.log(error);
    }
    return [];
}

export const getHiringFlowByJob = async (tenant : string | undefined,payLoad:any) =>{
    try{
        const response = await postJsonRequest(apiUrl.JM_GET_HIRING_FLOW_BY_JOB,payLoad,tenant,true)

        if(response.status === 200){
            const { Status,Data} =response.data

            return Status ? Data : []
        }
    }catch(error){
        console.log(error)
    }

    return []
}

export const getAllPanelMembers=async(tenant: string | undefined)=>{
    try{
        const response= await getRequest(apiUrl.UM_GET_ALL_PANEL_MEMBERS,{},tenant,true)
        if(response.status === 200){
            const {Status,Data} = response.data

            return Status ? Data : []
        }
    }catch(error){
        console.log(error)
    }

    return []

}

export const sendEmailsToStakeholders=async (tenant: string | undefined, payLoad:any) =>{
    try{
        const response = await postJsonRequest(apiUrl.UM_POST_SEND_EMAILS_TO_STAKEHOLDERS,payLoad,tenant,true)

        if(response.status === 200){
            const {Status}=response.data

            return Status
        }
    }catch(error){
        console.log(error)
    }

    return false
}

export const updateCandidateEmail = async (tenant: string | undefined, payLoad: any) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_POST_UPDATE_CANDIDATE_EMAIL, payLoad, tenant, true);
        if (response.status === 200) {
            const { Status, Message } = response.data;

            return { Status, Message };
        }
    } catch (error) {
        console.log(error);
    }
    return null;
}